import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import GridLayout from './components/GridLayout.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

